import { z } from 'zod';
export const checkoutSchema = z.object({ planCode: z.string().trim().min(1).max(40) });
/** A GSTIN: 2 digit state code, 10 character PAN, entity number, Z, check character. */
const GSTIN = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
export const billingDetailsSchema = z
    .object({
    gstin: z
        .string()
        .trim()
        .toUpperCase()
        .regex(GSTIN, 'Enter a valid GSTIN')
        .nullable()
        .optional(),
    billingState: z
        .string()
        .regex(/^\d{2}$/, 'Use the 2 digit GST state code')
        .optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Provide at least one field');
/** A fake gateway event, sent by the dev billing page (development and test only). */
export const devBillingEventSchema = z.object({
    type: z.enum(['payment.succeeded', 'payment.failed', 'subscription.cancelled']),
    /** Repeat the same id to see a replay do nothing. */
    eventId: z.string().min(1).max(80).optional(),
    /** Pretend the event happened earlier, in minutes, to test out of order delivery. */
    minutesAgo: z.number().int().min(0).max(525_600).optional(),
});
export const devBillingDatesSchema = z.object({
    trialEndsAt: z.string().datetime().nullable().optional(),
    graceEndsAt: z.string().datetime().nullable().optional(),
    currentPeriodEnd: z.string().datetime().nullable().optional(),
});
//# sourceMappingURL=billing.js.map